module.exports = __webpack_public_path__ + "img/sppr_0601.da50ee7e.jpg";